import { cx } from '#packages/util';
import React, { type FC } from 'react';
import styles from './gridLines.scss';
import type { GridLine } from 'types/core';

interface GridLinesProps {
  dataHook?: string;
  gridLines: GridLine[];
  fade?: boolean;
}

const GridLines: FC<GridLinesProps> = ({
  fade = false,
  gridLines,
  dataHook = '',
}) => (
  <svg
    data-hook={dataHook}
    className={cx(styles.gridLines, { [styles.fade]: fade })}
  >
    {gridLines.map((gridLine, gridLineIndex) => (
      <line
        key={`${gridLineIndex}backLine`}
        x1={gridLine.x1}
        y1={gridLine.y1}
        x2={gridLine.x2}
        y2={gridLine.y2}
        className={styles.backLine}
      />
    ))}
    {gridLines.map((gridLine, gridLineIndex) => (
      <line
        key={`${gridLineIndex}frontLine`}
        x1={gridLine.x1}
        y1={gridLine.y1}
        x2={gridLine.x2}
        y2={gridLine.y2}
        className={styles.frontLine}
      />
    ))}
  </svg>
);

export default GridLines;
